import React from 'react'

const RadioCheckedIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.5' y='0.5' width='19' height='19' rx='9.5' fill='#402080' stroke='#402080' />
      <g>
        <path d='M4 9.5L8 13.5L16 6' stroke='white' />
      </g>
      <defs>
        <clipPath id='clip0_21009_109675'>
          <rect width='14' height='14' fill='white' transform='translate(3 3)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RadioCheckedIcon
